export default {
  validateStaffName: (state) => {
    return state.staffTypeName
  },
}
